import { GridColDef } from "@mui/x-data-grid";
import { renderDate } from "../../../../component/list/table-column-renders";

export const columns: GridColDef[] = [
    { field: 'day', headerName: 'Day', flex: 1, valueFormatter: (params) => { return renderDate(params.value) } },
    { field: 'cohortName', headerName: 'Cohort', flex: 1 },
    { field: 'attendance', headerName: 'Attendance', flex: 0.5 }
];